/* RegexUtils.js */

"use strict";
const _ = require("lodash");

class RegexUtils {
    static isRegexValid(val) {
        let isValid = true;
        try {
            new RegExp(val);
        } catch (e) {
            isValid = false;
        }
        return isValid;
    }

    static getRegexWithMatchingGroups(regex, addGroupNamesIfMissing = false) {
        if (!regex) {
            return regex;
        }
        let regexWithMatchingGroups = regex;
        let charsInserted = 0;
        let paranthesesMatch = this._findNextOpeningParantheses(regex, 0);
        let namedGroupRegex = new RegExp("(?<=\\()\\?<(?<groupName>[^>]+)>");
        let regexQuantifierRegex = new RegExp("(\\*|\\+|\\?|{\\d+}|{\\d+,}|{\\d+,\\d+})(\\?){0,1}");
        let currentIndex = 0;
        let groupsInserted = 0;
        let nonNamedGroupsCount = 0;
        while (paranthesesMatch !== null) {
            //if next group starts at current index
            if (paranthesesMatch.index === currentIndex) {
                let groupEndIndex;
                let namedGroupMatch = namedGroupRegex.exec(regex.substring(currentIndex));
                let isCurrentGroupNamedGroup = namedGroupMatch
                    ? namedGroupMatch.index === 1
                    : false; //regex.substring(currentIndex).search(namedGroupRegex) === 1;
                let isNonCapturingGroup =
                    !isCurrentGroupNamedGroup && regex.substring(currentIndex).startsWith("(?:");
                paranthesesMatch = RegexUtils._findNextClosingParantheses(regex, currentIndex); // find next ')'
                groupEndIndex = RegexUtils._getParanthesesIndexFromTheMatch(paranthesesMatch) + 1;
                let quantifierMatch = regexQuantifierRegex.exec(regex.substring(groupEndIndex));
                if (quantifierMatch && quantifierMatch.index === 0) {
                    //found quantifier after group construct
                    //convert the group construct into non capturing group
                    let addedGroup = addGroupNamesIfMissing
                        ? "(?<$$NotANamedGroup" + nonNamedGroupsCount + ">"
                        : "(";
                    nonNamedGroupsCount++;
                    if (isCurrentGroupNamedGroup) {
                        //replace named group (?<groupName> with (?:;
                        let namedGroupLength = namedGroupMatch.groups.groupName.length + 2; // + 2 for angular brackets surrounding groupname  <groupname>
                        regexWithMatchingGroups =
                            regexWithMatchingGroups.substring(0, currentIndex + charsInserted) +
                            addedGroup +
                            "(?:" +
                            regexWithMatchingGroups.substring(
                                currentIndex + charsInserted + 2 + namedGroupLength
                            );
                        charsInserted = charsInserted + addedGroup.length - namedGroupLength + 1;
                    } else if (!isNonCapturingGroup) {
                        regexWithMatchingGroups =
                            regexWithMatchingGroups.substring(0, currentIndex + charsInserted) +
                            addedGroup +
                            "(?:" +
                            regexWithMatchingGroups.substring(currentIndex + charsInserted + 1);
                        charsInserted += addedGroup.length + 2;
                    } else {
                        regexWithMatchingGroups =
                            regexWithMatchingGroups.substring(0, currentIndex + charsInserted) +
                            addedGroup +
                            regexWithMatchingGroups.substring(currentIndex + charsInserted);
                        charsInserted += addedGroup.length;
                    }
                    regexWithMatchingGroups =
                        regexWithMatchingGroups.substring(0, groupEndIndex + charsInserted) +
                        quantifierMatch[0] +
                        ")" +
                        regexWithMatchingGroups.substring(groupEndIndex + charsInserted + 1);
                    charsInserted++;
                } else {
                    quantifierMatch = null;
                    if (addGroupNamesIfMissing && !isCurrentGroupNamedGroup) {
                        let namedGroup = "?<$$NotANamedGroup" + nonNamedGroupsCount + ">";
                        nonNamedGroupsCount++;
                        if (isNonCapturingGroup) {
                            regexWithMatchingGroups =
                                regexWithMatchingGroups.substring(
                                    0,
                                    currentIndex + charsInserted + 1
                                ) +
                                namedGroup +
                                regexWithMatchingGroups.substring(currentIndex + charsInserted + 3);
                            charsInserted += namedGroup.length - 2;
                        } else {
                            regexWithMatchingGroups =
                                regexWithMatchingGroups.substring(
                                    0,
                                    currentIndex + charsInserted + 1
                                ) +
                                namedGroup +
                                regexWithMatchingGroups.substring(currentIndex + charsInserted + 1);
                            charsInserted += namedGroup.length;
                        }
                    }
                }
                currentIndex = groupEndIndex + (quantifierMatch ? quantifierMatch[0].length : 0);
                paranthesesMatch = RegexUtils._findNextOpeningParantheses(regex, currentIndex); // find next '('
            } else {
                // add a new group for text not wrapped in parantheses
                let pipeMatch = RegexUtils._getPipeMatch(
                    regex.substring(currentIndex, paranthesesMatch.index),
                    0
                );
                if (pipeMatch && pipeMatch.index === 0) {
                    currentIndex = currentIndex + pipeMatch[0].length;
                } else {
                    let groupEndIndex = pipeMatch
                        ? currentIndex + pipeMatch.index + pipeMatch[0].length - 1
                        : paranthesesMatch.index;
                    let namedGroupToInsert = addGroupNamesIfMissing
                        ? "?<$$AddedGroup" + groupsInserted + ">"
                        : "";
                    regexWithMatchingGroups =
                        regexWithMatchingGroups.substring(0, currentIndex + charsInserted) +
                        "(" +
                        namedGroupToInsert +
                        regexWithMatchingGroups.substring(
                            currentIndex + charsInserted,
                            groupEndIndex + charsInserted
                        ) +
                        ")" +
                        regexWithMatchingGroups.substring(groupEndIndex + charsInserted);
                    currentIndex = pipeMatch
                        ? groupEndIndex + 1
                        : RegexUtils._getParanthesesIndexFromTheMatch(paranthesesMatch); // find next '('
                    groupsInserted++;
                    charsInserted += 2 + namedGroupToInsert.length;
                }
            }
        }
        if (currentIndex < regex.length - 1) {
            do {
                let pipeMatch = RegexUtils._getPipeMatch(regex.substring(currentIndex), 0);
                if (pipeMatch && pipeMatch.index === 0) {
                    currentIndex = currentIndex + pipeMatch[0].length;
                } else {
                    let groupEndIndex = pipeMatch
                        ? currentIndex + pipeMatch.index + pipeMatch[0].length - 1
                        : regex.length;
                    let namedGroupToInsert = addGroupNamesIfMissing
                        ? "?<$$AddedGroup" + groupsInserted + ">"
                        : "";
                    regexWithMatchingGroups =
                        regexWithMatchingGroups.substring(0, currentIndex + charsInserted) +
                        "(" +
                        namedGroupToInsert +
                        regexWithMatchingGroups.substring(
                            currentIndex + charsInserted,
                            groupEndIndex + charsInserted
                        ) +
                        ")" +
                        regexWithMatchingGroups.substring(groupEndIndex + charsInserted);
                    groupsInserted++;
                    charsInserted += 2 + namedGroupToInsert.length;
                    currentIndex = pipeMatch ? groupEndIndex + 1 : regex.length;
                }
            } while (currentIndex < regex.length - 1);
        }
        let regexWithNonCapturingNestedGroups =
            this._convertNestedGroupsToNonCapturedGroups(regexWithMatchingGroups);
        return regexWithNonCapturingNestedGroups;
    }

    static _getParanthesesIndexFromTheMatch(paranthesesMatch) {
        return (
            paranthesesMatch.index +
            (paranthesesMatch.groups.forwardslash ? paranthesesMatch.groups.forwardslash.length : 0)
        );
    }

    static _findNextOpeningParantheses(inputString, startIndex) {
        let match = this._findChar(inputString.substring(startIndex), "(");
        if (match) {
            match.index += startIndex;
        }
        return match;
    }

    static _findNextClosingParantheses(inputString, startIndex) {
        let match = this._findChar(inputString.substring(startIndex + 1), ")");
        if (match) {
            match.index += startIndex + 1;
        }
        return match;
    }

    static isLiteralParantheses(match) {
        return _.get(match, "groups.forwardslash.length", 0) % 2 === 1;
    }

    static _getPipeMatch(inputString, startIndex) {
        let match = this._findChar(inputString.substring(startIndex), "|");
        if (match) {
            match.index += startIndex;
        }
        return match;
    }

    static _findChar(inputString, searchChar) {
        if (!searchChar) {
            return null;
        }
        let searchRegex =
            searchChar === ")"
                ? new RegExp(
                      "(?<forwardslash>(\\\\)*)((?<searchCharGroup>\\" +
                          searchChar +
                          ")|(?<squareBrace>\\[)|(?<openingParantheses>\\())",
                      "g"
                  )
                : new RegExp(
                      "(?<forwardslash>(\\\\)*)((?<searchCharGroup>\\" +
                          searchChar +
                          ")|(?<squareBrace>\\[))",
                      "g"
                  );
        let match;
        let searchSuccessful = false;
        let searchStartIndex = 0;
        do {
            match = searchRegex.exec(inputString.substring(searchStartIndex));
            if (
                match &&
                match.groups.searchCharGroup === searchChar &&
                !RegexUtils._isLiteralMatch(match)
            ) {
                searchSuccessful = true;
                if (searchStartIndex !== 0) {
                    match.index = searchStartIndex + match.index;
                }
            } else if (match && match.groups.squareBrace === "[" && !this._isLiteralMatch(match)) {
                //ignore all pipes inside [] as these are treated as literal pipes
                let openingSquareBraceIndex = searchStartIndex + match.index;
                let closingSquareBraceMatch = this._findClosingSquareBrace(
                    inputString,
                    openingSquareBraceIndex
                );
                searchStartIndex = openingSquareBraceIndex + closingSquareBraceMatch.index;
                searchRegex.lastIndex = 0; //reset searchRegex to start search given string after recent closing square brace
            } else if (
                searchChar === ")" &&
                match &&
                match.groups.openingParantheses === "(" &&
                !this._isLiteralMatch(match)
            ) {
                let closingParanthesesIndex = this._findClosingParanthesesInNestedGroup(
                    inputString.substring(searchStartIndex + match.index)
                );
                //consider forwardslash length when returning closing parantheses index
                searchStartIndex = searchStartIndex + match.index + closingParanthesesIndex + 1;
                searchRegex.lastIndex = 0;
            }
        } while (match && !searchSuccessful);
        return searchSuccessful ? match : null;
    }

    static _isLiteralMatch(match) {
        return match && _.get(match, "groups.forwardslash.length", 0) % 2 === 1;
    }

    static _findClosingSquareBrace(inputString, openingSquareBraceIndex) {
        let closingSquareBrace = new RegExp("(?<forwardslash>(\\\\)*)(?<squareBrace>\\])", "g");
        let closingSquareBraceMatch;
        do {
            closingSquareBraceMatch = closingSquareBrace.exec(
                inputString.substring(openingSquareBraceIndex)
            );
        } while (closingSquareBraceMatch && this._isLiteralMatch(closingSquareBraceMatch));
        return closingSquareBraceMatch;
    }

    static _findClosingParanthesesInNestedGroup(inputString) {
        let searchRegex = new RegExp("(?<forwardslash>(\\\\)*)(?<searchGroup>(\\)|\\(|\\[))", "g");
        let stack = [];
        let searchStartIndex = 0;
        let match;
        do {
            match = searchRegex.exec(inputString.substring(searchStartIndex));
            if (match && match.groups.searchGroup === "(" && !this._isLiteralMatch(match)) {
                stack.push("(");
            } else if (match && match.groups.searchGroup === ")" && !this._isLiteralMatch(match)) {
                stack.pop();
            } else if (match && match.groups.searchGroup === "[" && !this._isLiteralMatch(match)) {
                let openingSquareBraceIndex = searchStartIndex + match.index;
                let closingSquareBraceMatch = this._findClosingSquareBrace(
                    inputString,
                    openingSquareBraceIndex
                );
                searchStartIndex = openingSquareBraceIndex + closingSquareBraceMatch.index;
                searchRegex.lastIndex = 0;
            }
        } while (!_.isEmpty(stack) && match);
        if (match) {
            match.index = match.index + searchStartIndex;
        }
        return match ? match.index : -1;
    }

    static _convertNestedGroupsToNonCapturedGroups(inputString) {
        if (!inputString) {
            return inputString;
        }
        let searchRegex = new RegExp("(?<forwardslash>(\\\\)*)(?<searchGroup>(\\)|\\(|\\[))", "g");
        let stack = [];
        let searchStartIndex = 0;
        let match;
        let nonCapturingGroups = inputString;
        let charsInserted = 0;
        do {
            match = searchRegex.exec(inputString.substring(searchStartIndex));
            if (match && match.groups.searchGroup === "(" && !this._isLiteralMatch(match)) {
                stack.push("(");
                if (stack.length > 1) {
                    //convert to non capturing groups on nested groups
                    let groupStartIndex = searchStartIndex + match.index + match[0].length - 1;
                    if (inputString.substring(groupStartIndex).startsWith("(?<")) {
                        let groupNameEndIndex =
                            groupStartIndex + inputString.substring(groupStartIndex).indexOf(">");
                        nonCapturingGroups =
                            nonCapturingGroups.substring(0, groupStartIndex + charsInserted + 1) +
                            "?:" +
                            nonCapturingGroups.substring(groupNameEndIndex + charsInserted + 1);
                        charsInserted += 2 - (groupNameEndIndex - groupStartIndex);
                    } else if (!inputString.substring(groupStartIndex).startsWith("(?:")) {
                        nonCapturingGroups =
                            nonCapturingGroups.substring(0, groupStartIndex + charsInserted + 1) +
                            "?:" +
                            nonCapturingGroups.substring(groupStartIndex + charsInserted + 1);
                        charsInserted += 2;
                    }
                }
            } else if (match && match.groups.searchGroup === ")" && !this._isLiteralMatch(match)) {
                stack.pop();
            } else if (match && match.groups.searchGroup === "[" && !this._isLiteralMatch(match)) {
                let openingSquareBraceIndex = searchStartIndex + match.index;
                let closingSquareBraceMatch = this._findClosingSquareBrace(
                    inputString,
                    openingSquareBraceIndex
                );
                searchStartIndex = openingSquareBraceIndex + closingSquareBraceMatch.index;
                searchRegex.lastIndex = 0;
            }
        } while (match);
        return nonCapturingGroups;
    }

    static _addGroupCoveringAllRegex(regex, addGroupNamesIfMissing = false) {
        if (!this.isRegexWrappedWithParantheses(regex)) {
            let namedGroupStr = addGroupNamesIfMissing ? "?<$$MatchAllGroup>" : "";
            return "(" + namedGroupStr + regex + ")";
        } else {
            return regex;
        }
    }

    static isRegexWrappedWithParantheses(regex) {
        let wrappedWithParantheses = false;
        let regexMatchingParantheses = new RegExp(
            "(?<forwardslash>(\\\\)*)(?<parantheses>(\\)|\\())",
            "g"
        );
        if (!regex || !regex.startsWith("(")) {
            return wrappedWithParantheses;
        }
        let paranthesesMatch = regexMatchingParantheses.exec(regex);
        let paranthesesStack = ["("];

        while ((paranthesesMatch = regexMatchingParantheses.exec(regex)) !== null) {
            let numberOfForwardSlashes = paranthesesMatch.groups.forwardslash
                ? paranthesesMatch.groups.forwardslash.length
                : 0;
            if (numberOfForwardSlashes % 2 === 0) {
                if (paranthesesMatch.groups.parantheses === ")") {
                    if (paranthesesStack.length > 0) {
                        paranthesesStack.pop();
                        if (paranthesesStack.length === 0) {
                            wrappedWithParantheses =
                                paranthesesMatch.index + numberOfForwardSlashes + 1 ===
                                regex.length;
                            break;
                        }
                    } else {
                        break;
                    }
                } else {
                    //if '(' opening parantheses found
                    paranthesesStack.push("(");
                }
            }
        }
        return wrappedWithParantheses;
    }

    static getNamedGroupDetails(match, namedGroupsList, TOKEN_COLORS) {
        let groupStartIndex = 0;
        let expectedString = "";
        let namedGroupsDetails = [];
        if (!match || !match.groups || _.isEmpty(namedGroupsList)) {
            return namedGroupsDetails;
        }
        let containsUserDefinedNamedGroups = false;
        for (let i = 0; i < namedGroupsList.length && !containsUserDefinedNamedGroups; i++) {
            let groupName = namedGroupsList[i];
            if (
                !_.isEmpty(match.groups[groupName]) &&
                !(groupName.startsWith("$$AddedGroup") || groupName.startsWith("$$NotANamedGroup"))
            ) {
                containsUserDefinedNamedGroups = true;
            }
        }
        for (let i = 0; i < namedGroupsList.length; i++) {
            let groupName = namedGroupsList[i];
            let groupValue = match.groups[groupName];
            if (groupValue) {
                expectedString += groupValue;
                groupStartIndex = match[0].indexOf(groupValue, groupStartIndex);
                if (!match[0].startsWith(expectedString)) {
                    expectedString = match[0].substr(0, groupStartIndex + groupValue.length);
                }
                if (groupName.startsWith("$$AddedGroup")) {
                    if (!containsUserDefinedNamedGroups) {
                        namedGroupsDetails.push({
                            name: groupName,
                            value: groupValue,
                            startIndex: groupStartIndex,
                            token: "regex",
                        });
                    }
                } else if (!groupName.startsWith("$$NotANamedGroup")) {
                    let token = TOKEN_COLORS[namedGroupsDetails.length % TOKEN_COLORS.length];
                    namedGroupsDetails.push({
                        name: groupName,
                        value: groupValue,
                        startIndex: groupStartIndex,
                        token: token,
                    });
                }
                groupStartIndex += groupValue.length;
            } else {
                if (
                    !(
                        groupName.startsWith("$$AddedGroup") ||
                        groupName.startsWith("$$NotANamedGroup")
                    )
                ) {
                    namedGroupsDetails.push({
                        name: groupName,
                        value: "",
                        startIndex: -1,
                        token: null,
                    });
                }
            }
        }
        return namedGroupsDetails;
    }
}

RegexUtils.MATCH_ALL_REGEX = [".+", "(.+)", ".*", "(.*)"];

module.exports = RegexUtils;
